export var ChatEventName = {
    MESSAGE_READ: 'Chat Message Read',
    MESSAGE_SENT: 'Chat Message Sent',
    OPENED: 'Chat Opened',
    OPENED_FROM_EMAIL: 'Chat Opened From Email',
    FIRST_MESSAGE_SENT: 'Chat First Message Sent',
    OTP_ENTERED: 'Chat OTP Entered',
    FIRST_NAME_ENTERED: 'Chat First Name Entered',
    NO_RESPONSE_MESSAGE_SENT: 'Chat No Response Message Sent',
    PHONE_NUMBER_ENTERED: 'Chat Phone Number Entered',
    EMAIL_ENTERED: 'Chat Email Entered',
    TRANSITIONED_FROM_SMART_TO_LENDI: 'Chat Transitioned From Smart To Lendi',
    USER_AUTHENTICATED: 'User Authenticated',
    CONTACT_US_SHOWN: 'Contact Us Shown',
    PHONE_NUMBER_CHANGED: 'Phone Number Changed',
    CHAT_OPENED_FROM_EXTERNAL: 'Link Clicked',
    OPEN_FROM_EMAIL: 'Chat Opened From Email',
    SUBMIT_FORM_CLICKED: 'Chat Submit Form Clicked',
};
//# sourceMappingURL=types.js.map